export { default } from "./SurveyTabs/SurveyTabs";
